import { useEffect, useState } from 'react';
import Script from 'next/script';
import { Action } from '../models/action';
import { ACTION_TYPES } from '../models/action-types';
import { ConfigTypes } from '../models/config';
import { useAuthorization } from '../providers/authorization';

function useTSNextWidget({
  eventData,
  configOfSite,
}: {
  eventData: Action;
  configOfSite: ConfigTypes;
}) {
  const [tsNextWidgetConfig, setTsNextWidgetConfig] = useState<null | {
    jsUrl: string;
    appId: string;
    id: string;
    type: string;
  }>(null);
  const [isScriptLoaded, setIsScriptLoaded] = useState(false);
  const [isFakeClicked, setFakeClicked] = useState(false);
  const auth = useAuthorization();

  function fakeClick() {
    setFakeClicked(true);
  }

  useEffect(() => {
    if (eventData.type === ACTION_TYPES.tsnext_widget && auth.isReady) {
      const tsNextWidgetJsUrl = configOfSite.find(
        (item) => item.name === 'TSNEXT_JS_URL'
      );
      const appIdNextWidget = configOfSite.find(
        (item) => item.name === 'TSNEXT_APP_TOKEN'
      );

      setTsNextWidgetConfig({
        jsUrl: `${tsNextWidgetJsUrl?.value}`,
        appId: `${appIdNextWidget?.value}`,
        id: eventData.tsnext_id,
        type: eventData.tsnext_type,
      });
    } else {
      setTsNextWidgetConfig(null);
    }
  }, [configOfSite, eventData, auth]);

  useEffect(() => {
    if (
      !isScriptLoaded &&
      isFakeClicked &&
      tsNextWidgetConfig &&
      auth.isReady
    ) {
      const button = document.querySelector(
        '.tsnext-widget'
      ) as HTMLButtonElement;
      if (button) {
        const onFakeClick = (tryCount: number) => {
          if (!document.querySelector('#payment-form') && tryCount < 5) {
            button.click();
            setTimeout(() => onFakeClick(tryCount + 1), 1000);
          }
        };
        onFakeClick(0);
      }
    }
  }, [isFakeClicked, isScriptLoaded, tsNextWidgetConfig, auth]);

  function TSNextWidgetScript() {
    return (
      tsNextWidgetConfig && (
        <>
          <Script id='for-new-widget'>{`var ppid = "${tsNextWidgetConfig.appId}"`}</Script>
          <Script
            onReady={() => setIsScriptLoaded(true)}
            src={tsNextWidgetConfig.jsUrl}
          />
        </>
      )
    );
  }
  return { TSNextWidgetScript, tsNextWidgetConfig, fakeClick };
}

export { useTSNextWidget };
